var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children } from "react";
import PropTypes from "prop-types";
var FooterBody = function (props) {
    var operatorHref = props.operatorHref, operatorLogo = props.operatorLogo, logoWidth = props.logoWidth, altText = props.altText, children = props.children, className = props.className, 
    // @ts-ignore
    __TYPE = props.__TYPE, remainingProps = __rest(props, ["operatorHref", "operatorLogo", "logoWidth", "altText", "children", "className", "__TYPE"]);
    var logoElement = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return child && child.props && child.props.__TYPE === "LogoMj";
    });
    var content = Children.toArray(children).filter(function (child) {
        // @ts-ignore
        return "props" in child && child.props.__TYPE === "FooterContent";
    });
    return (React.createElement("div", __assign({}, remainingProps, { className: "fr-footer__body" }),
        React.createElement("div", { className: "fr-footer__brand fr-enlarge-link" },
            logoElement,
            operatorHref && (React.createElement("a", { className: "fr-footer__brand-link", href: operatorHref },
                React.createElement("img", { className: "fr-footer__logo", src: operatorLogo, style: { maxWidth: logoWidth }, alt: altText })))),
        content));
};
FooterBody.defaultProps = { __TYPE: "FooterBody" };
FooterBody.propTypes = { __TYPE: PropTypes.string };
export default FooterBody;
